// guestTypeApi.js
import axios from "axios";
import querystring from "querystring";
import { getUserData, configFetch } from "./config";

const HOSTNAME = process.env.REACT_APP_API_URL || "http://localhost:8080";

const API_SERVICES = {
  GuestTypeIndex: `${HOSTNAME}/guesttype/index`,
  GuestTypeAdd: `${HOSTNAME}/guesttype/add`,
  GuestTypeUpdate: `${HOSTNAME}/guesttype/update`,
  GuestTypeDelete: `${HOSTNAME}/guesttype/delete`,
};

// Function to fetch guest types
export const fetchGuestTypes = async (params) => {
  try {
    const userData = getUserData();
    const url = `${API_SERVICES.GuestTypeIndex}?${querystring.stringify(params)}`;
    const response = await axios(configFetch(url, "get", null, true, {
      Authorization: `Bearer ${userData.token}`,
    }));
    return response.data;
  } catch (error) {
    console.error("Error fetching guest types:", error.message);
    throw error;
  }
};

// Function to add a guest type
export const addGuestType = async (data) => {
  try {
    const userData = getUserData();
    const response = await axios(configFetch(API_SERVICES.GuestTypeAdd, "post", data, true, {
      Authorization: `Bearer ${userData.token}`,
    }));
    return response.data;
  } catch (error) {
    console.error("Error adding guest type:", error.message);
    throw error;
  }
};

// Function to update a guest type
export const updateGuestType = async (data) => {
  try {
    const userData = getUserData();
    const response = await axios(configFetch(API_SERVICES.GuestTypeUpdate, "put", data, true, {
      Authorization: `Bearer ${userData.token}`,
    }));
    return response.data;
  } catch (error) {
    console.error("Error updating guest type:", error.message);
    throw error;
  }
};

// Function to delete a guest type
export const deleteGuestType = async (id) => {
  try {
    const userData = getUserData();
    await axios(configFetch(`${API_SERVICES.GuestTypeDelete}`, "delete", id, true, {
      Authorization: `Bearer ${userData.token}`,
    }));
  } catch (error) {
    console.error("Error deleting guest type:", error.message);
    throw error;
  }
};
